import billingService from '@/app-domains/user/billing/billing.service'
import sessionService from '@/app-domains/user/session/session.service'
import { SimpleBanner } from '@/components/Banners/SimpleBanner'
import { Button } from '@/components/Button/Button'
import { LoadingSpinner } from '@/components/LoadingSpinner'
import { centsToDollars } from '@/helpers/currency.helper'
import modalService from '@/services/modal.service'
import React, { useEffect, useState } from 'react'
import store from '@/core/store'
import { ReactComponent as CrossIcon } from '@/assets/icons/editor/cross-times-chip.svg'

import './CancelSubscriptionModal.scoped.sass'

export function CancelSubscriptionModal () {
  const [subscriptionData, setSubscriptionData] = useState()
  const defaultDomain = sessionService.getMe().me.defaultdomain
  useEffect(async () => {
    // Call here API for getting cancelling subscription data
    const data = await billingService.getCancelSubscriptionData()
    setSubscriptionData(data)
  }, [])
  function userHasRefund () {
    // User doesn't have refund for most of the cases except in the 11th month of each year of subscription
    return true
  }

  async function cancelSubscriptionWithType (type) {
    await billingService.cancelSubscription(type)
    modalService.close()
    store.commit('SUBSCRIPTION:CHANGED')
  }

  function domainIsManagedByBoxes () {
    return true
  }

  function getDomainCost () {
    return centsToDollars(subscriptionData.renewalPrice / 100)
  }

  function getRefundAmount () {
    return centsToDollars(subscriptionData.upfrontAmountPaid / 100)
  }
  return (<div className='cancel-subscription-modal'>
    <div className='cancel-subscription-header'>
      <div>
        <p className='main-phrase'>We are sad to see you go!</p>
        <p className='main-subphrase'>( But we will try to make it as simple as possible )</p>
      </div>
      <div className='close-icon' onClick={() => modalService.close()}><CrossIcon/></div>
    </div>
    { subscriptionData
      ? <div className='cancel-subscription-content'>
        <p>
          <SimpleBanner type='warning'>
            <span className='font-medium'>REMEMBER:</span><br/>
            Boxes is a one-of-a-kind service, so once canceled all the different emails addresses (Boxes) you have set up will no longer function.
            <br/><br/>
            You own your data and after you cancel we will send you a message with a link where you can download your data and attachments to your computer.
          </SimpleBanner>
          { userHasRefund() &&
          <SimpleBanner type='info'>
            <span className='inline-block font-medium mb-xxs'>You get a refund!</span>
            <br/>
            Each month of service, we hold back 1/12th of your annual domain payment for the upcoming year.
            <br/>
            You have a refund due of <b>{getRefundAmount()}</b>.
          </SimpleBanner>
      }
        </p>
        { domainIsManagedByBoxes() && <p className='mt-l'>
          <span className='inline-block font-medium text-sm mb-xs'>Your most important decision is what to do with your domain <b>{defaultDomain}</b></span>
          <br/>
          <span className='inline-block font-light mb-xxs'>Do you want to keep your domain name?</span>
          <br/>
          <span className='inline-block font-extralight text-xs mb-xxs'>
            The annual cost to keep your domain is {getDomainCost()}
            <br/>
            You can also transfer your domain to another provider like GoDaddy or Hosting.com
          </span>
        </p> }
        <p>
          If you are absolutely sure you want to cancel, click the one of the links below and we will begin the process for you:
        </p>
        <div className='cancel-options'>
          { domainIsManagedByBoxes()
            ? <>
              <a className='cancel-option' onClick={() => cancelSubscriptionWithType('dont-keep-domain')}>Cancel my Boxes service and I don't want to keep my domain ($0 annual cost)</a>
              <a className='cancel-option' onClick={() => cancelSubscriptionWithType('keep-domain')}>{`Cancel my Boxes service but I want to keep my domain (${getDomainCost()} annual cost)`}</a>
              <a className='cancel-option' onClick={() => cancelSubscriptionWithType('transfer-domain')}>Cancel my Boxes service and I want to transfer my domain</a>
            </>
            : <a className='cancel-option' onClick={() => cancelSubscriptionWithType('plain-cancel')}>Cancel my Boxes service</a>
    }
        </div>
      </div>
      : <div className='loading-data'><LoadingSpinner/></div>}
    { subscriptionData && <div className='cancel-actions'>
      <div className='close-cancel'>
        <Button content="Nevermind, I don't want to cancel" type='primary' click={() => modalService.close()}/>
      </div>
    </div>
    }
  </div>)
}
